<template>
    <v-container fluid>
        <v-layout class="align-center">
            <v-flex>
                <h2 class="headline">Lokasjoner</h2>
            </v-flex>
        </v-layout>

        <LocationList></LocationList>

        <v-btn class="mt-2" color="green darken-1" dark @click="printPage">
            <v-icon>print</v-icon>
            Skriv ut
        </v-btn>
    </v-container>
</template>

<script>
import LocationList from "../helpers/LocationList";

export default {
    name: 'LocationSummary',
    components: {
        LocationList
    },

    methods: {
        redirectToCar(car) {
            this.$router.push({name: 'CarShow', params: {id: car.id}});
        },


        printPage() {
            window.print();
        }
    }
}
</script>
